import $ from 'jquery';

const GO_BUTTON_START = "Publish";
const GO_BUTTON_STOP = "Stop";

var localVideo = null;
var remoteVideo = null;
var peerConnection = null;
var peerConnectionConfig = { 'iceServers': [] };
var localStream = null;
var wsURL = "wss://5ad482a77183d.streamlock.net/webrtc-session.json";
var wsConnection = null;
var userData = { param1: "value1" };
var videoBitrate = 1024;
var audioBitrate = 160;
var videoFrameRate = "30";
var userAgent = "relaystream:live";
var newAPI = false;

navigator.getUserMedia = navigator.getUserMedia || navigator.mozGetUserMedia || navigator.webkitGetUserMedia;
window.RTCPeerConnection = window.RTCPeerConnection || window.mozRTCPeerConnection || window.webkitRTCPeerConnection;
window.RTCIceCandidate = window.RTCIceCandidate || window.mozRTCIceCandidate || window.webkitRTCIceCandidate;
window.RTCSessionDescription = window.RTCSessionDescription || window.mozRTCSessionDescription || window.webkitRTCSessionDescription;


export function getVideoProperties() {
	return {
		videoBitrate: videoBitrate,
		audioBitrate: audioBitrate,
		videoFrameRate: videoFrameRate
	}
}

export function setVideoProperties(vidBitrate, audBitrate, vidFrameRate) {
	videoBitrate = vidBitrate;
	audioBitrate = audBitrate;
	videoFrameRate = vidFrameRate;
}

export function pageReady() {
	var cookieWSURL = wsURL;
	$.cookie("webrtcPublishWSURL", cookieWSURL);
	console.log('cookieWSURL: ' + cookieWSURL);
	var cookieApplicationName = window.localStorage.getItem('wowzaAppName');
	$.cookie("webrtcPublishApplicationName", cookieApplicationName);
	console.log('cookieApplicationName: ' + cookieApplicationName);

	var cookieStreamName = window.localStorage.getItem('wowzaAppName');
	$.cookie("webrtcPublishStreamName", cookieStreamName);
	console.log('cookieStreamName: ' + cookieStreamName);

	var cookieVideoBitrate = videoBitrate;
	$.cookie("webrtcPublishVideoBitrate", cookieVideoBitrate);

	var cookieAudioBitrate = audioBitrate;
	$.cookie("webrtcPublishAudioBitrate", cookieAudioBitrate);

	var cookieVideoFrameRate = videoFrameRate;
	$.cookie("webrtcPublishVideoFrameRate", cookieVideoFrameRate);
	console.log('cookieVideoFrameRate: ' + cookieVideoFrameRate);

	if (userAgent == null) {
		userAgent = "relaystream:live";
	}

	$("#buttonGo").attr('value', GO_BUTTON_START);

	localVideo = document.getElementById('localVideo');
	localVideo.controls = true;
	localVideo.autoplay = true;
	localVideo.muted = true;

	/*
		// firefox
		video: {
			width: { min: 1280, ideal: 1280, max: 1920 },
			height: { min: 720, ideal: 720, max: 1080 }
		  },

		// chrome
		video: {
			mandatory: {
				minWidth: 1280,
				maxWidth: 1280,
				minHeight: 720,
				maxHeight: 720,
				minFrameRate: 30,
				maxFrameRate: 30
			}
		},

		video: {
			mandatory: {
				minAspectRatio: 1.7777777778
			}
		},

		video: true,
	*/

	var constraints =
	{
		video: true,
		audio: true,
	};

	if (navigator.mediaDevices.getUserMedia) {
		newAPI = false;
		return navigator.mediaDevices.getUserMedia(constraints).then(getUserMediaSuccess).catch(errorHandler);
	}
	else if (navigator.getUserMedia) {
		return navigator.getUserMedia(constraints, getUserMediaSuccess, errorHandler);
	}
	else {
		alert('Your browser does not support getUserMedia API');
	}

	console.log("newAPI: " + newAPI);

}


export function screenPageReady(videoElement) {
	var cookieWSURL = wsURL;
	$.cookie("webrtcPublishWSURL", cookieWSURL);
	console.log('cookieWSURL: ' + cookieWSURL);

	var cookieApplicationName = window.localStorage.getItem('wowzaAppName');
	$.cookie("webrtcPublishApplicationName", cookieApplicationName);
	console.log('cookieApplicationName: ' + cookieApplicationName);

	var cookieStreamName = window.localStorage.getItem('wowzaAppName');
	$.cookie("webrtcPublishStreamName", cookieStreamName);
	console.log('cookieStreamName: ' + cookieStreamName);

	var cookieVideoBitrate = videoBitrate;
	$.cookie("webrtcPublishVideoBitrate", cookieVideoBitrate);
	console.log('cookieVideoBitrate: ' + cookieVideoBitrate);

	var cookieAudioBitrate = audioBitrate;
	$.cookie("webrtcPublishAudioBitrate", cookieAudioBitrate);
	console.log('cookieAudioBitrate: ' + cookieAudioBitrate);

	var cookieVideoFrameRate = videoFrameRate;
	$.cookie("webrtcPublishVideoFrameRate", cookieVideoFrameRate);
	console.log('cookieVideoFrameRate: ' + cookieVideoFrameRate);

	if (userAgent == null) {
		userAgent = "relaystream:live";
	}

	$("#buttonGo").attr('value', GO_BUTTON_START);

	localVideo = videoElement;
	var constraints =
	{
		video: {
			cursor: "always"
		  },
		  audio: false
		
	};

	if (navigator.mediaDevices.getUserMedia) {
		navigator.mediaDevices.getDisplayMedia(constraints).then(getUserMediaSuccessForScreenSharing).catch(errorHandler);
		newAPI = false;
	}
	else if (navigator.getUserMedia) {
		navigator.getUserMedia(constraints, getUserMediaSuccessForScreenSharing, errorHandler);
	}
	else {
		alert('Your browser does not support getUserMedia API');
	}

	console.log("newAPI: " + newAPI);

}

export function wsConnect(url) {
	wsConnection = new WebSocket(url);
	wsConnection.binaryType = 'arraybuffer';
	return new Promise((resolve, reject) => {

		wsConnection.addEventListener('error', function (event) {
			console.log('WebSocket error: ', event);
		});
		wsConnection.onopen = function () {
			console.log("wsConnection.onopen");

			peerConnection = new RTCPeerConnection(peerConnectionConfig);
			peerConnection.onicecandidate = gotIceCandidate;

			if (newAPI) {
				var localTracks = localStream.getTracks();
				window.stream = localTracks;
				for (var localTrack in localTracks) {
					peerConnection.addTrack(localTracks[localTrack], localStream);
				}
			}
			else {
				peerConnection.addStream(localStream);
			}

			peerConnection.createOffer(gotDescription, errorHandler);
		}

		wsConnection.onmessage = function (evt) {
			console.log("wsConnection.onmessage: " + evt.data);

			var msgJSON = JSON.parse(evt.data);

			var msgStatus = Number(msgJSON['status']);
			var msgCommand = msgJSON['command'];
			if (msgStatus != 200) {
				$("#sdpDataTag").html(msgJSON['statusDescription']);
				return stopPublisher();
			} else {
				$("#sdpDataTag").html("");

				var sdpData = msgJSON['sdp'];
				if (sdpData !== undefined) {
					// console.log('sdp: ' + msgJSON['sdp']);

					peerConnection.setRemoteDescription(new RTCSessionDescription(sdpData), function () {
						//peerConnection.createAnswer(gotDescription, errorHandler);
					}, errorHandler);
				}

				var iceCandidates = msgJSON['iceCandidates'];
				if (iceCandidates !== undefined) {
					for (var index in iceCandidates) {
						// console.log('iceCandidates: ' + iceCandidates[index]);

						peerConnection.addIceCandidate(new RTCIceCandidate(iceCandidates[index]));
					}
				}
			}
			if (wsConnection != null)
				wsConnection.close();
			wsConnection = null;
		}

		wsConnection.onclose = function () {
			console.log("wsConnection.onclose");
			resolve("wsConnection.onclose");
		}

		wsConnection.onerror = function (evt) {
			console.log("wsConnection.onerror: " + JSON.stringify(evt));

			$("#sdpDataTag").html('WebSocket connection failed: ' + wsURL);
			stopPublisher();
		}
	})
}

export function getUserMediaSuccess(stream) {
	console.log("getUserMediaSuccess: " + JSON.stringify(stream));

	localStream = stream;
	localVideo.srcObject = stream;
	return start();
}

export function getUserMediaSuccessForScreenSharing(stream) {
	console.log("getUserMediaSuccess: " + stream);
	localStream = stream;
	start();
}
export function startPublisher() {
	var streamInfo = { applicationName: window.localStorage.getItem("wowzaAppName"), streamName: window.localStorage.getItem("wowzaAppName"), sessionId: new Date() };

	$.cookie("webrtcPublishWSURL", wsURL, { expires: 365 });
	$.cookie("webrtcPublishApplicationName", streamInfo.applicationName, { expires: 365 });
	$.cookie("webrtcPublishStreamName", streamInfo.streamName, { expires: 365 });
	$.cookie("webrtcPublishVideoBitrate", videoBitrate, { expires: 365 });
	$.cookie("webrtcPublishAudioBitrate", audioBitrate, { expires: 365 });
	$.cookie("webrtcPublishVideoFrameRate", videoFrameRate, { expires: 365 });

	console.log("startPublisher: wsURL:" + wsURL + " streamInfo:" + JSON.stringify(streamInfo));
	// $("#buttonGo").attr('value', GO_BUTTON_STOP);
	return wsConnect(wsURL);

}

export function stopPublisher() {
	if (peerConnection != null)
		peerConnection.close();
	peerConnection = null;

	if (wsConnection != null)
		wsConnection.close();
	wsConnection = null;

	$("#buttonGo").attr('value', GO_BUTTON_START);

	console.log("stopPublisher");
	return;
}

export function start() {
	if (peerConnection == null)
		return startPublisher();
	else
		return stopPublisher();
}

export function gotIceCandidate(event) {
	if (event.candidate != null) {
		console.log('gotIceCandidate: ' + JSON.stringify({ 'ice': event.candidate }));
	}
}

export function gotDescription(description) {
	var enhanceData = new Object();
	var streamInfo = { applicationName: window.localStorage.getItem("wowzaAppName"), streamName: window.localStorage.getItem("wowzaAppName"), sessionId: new Date() };

	if (audioBitrate !== undefined)
		enhanceData.audioBitrate = Number(audioBitrate);
	if (videoBitrate !== undefined)
		enhanceData.videoBitrate = Number(videoBitrate);
	if (videoFrameRate !== undefined)
		enhanceData.videoFrameRate = Number(videoFrameRate);


	description.sdp = enhanceSDP(description.sdp, enhanceData);

	// console.log('gotDescription: ' + JSON.stringify({ 'sdp': description }));

	peerConnection.setLocalDescription(description, function () {

		wsConnection.send('{"direction":"publish", "command":"sendOffer", "streamInfo":' + JSON.stringify(streamInfo) + ', "sdp":' + JSON.stringify(description) + ', "userData":' + JSON.stringify(userData) + '}');

	}, function () { console.log('set description error') });
}

export function enhanceSDP(sdpStr, enhanceData) {
	var sdpLines = sdpStr.split(/\r\n/);
	var sdpSection = 'header';
	var hitMID = false;
	var sdpStrRet = '';

	for (var sdpIndex in sdpLines) {
		var sdpLine = sdpLines[sdpIndex];

		if (sdpLine.length <= 0)
			continue;

		sdpStrRet += sdpLine;

		if (sdpLine.indexOf("m=audio") === 0) {
			sdpSection = 'audio';
			hitMID = false;
		}
		else if (sdpLine.indexOf("m=video") === 0) {
			sdpSection = 'video';
			hitMID = false;
		}
		else if (sdpLine.indexOf("a=rtpmap") == 0) {
			sdpSection = 'bandwidth';
			hitMID = false;
		}

		if (sdpLine.indexOf("a=mid:") === 0 || sdpLine.indexOf("a=rtpmap") == 0) {
			if (!hitMID) {
				if ('audio'.localeCompare(sdpSection) == 0) {
					if (enhanceData.audioBitrate !== undefined) {
						sdpStrRet += '\r\nb=CT:' + (enhanceData.audioBitrate);
						sdpStrRet += '\r\nb=AS:' + (enhanceData.audioBitrate);
					}
					hitMID = true;
				}
				else if ('video'.localeCompare(sdpSection) == 0) {
					if (enhanceData.videoBitrate !== undefined) {
						sdpStrRet += '\r\nb=CT:' + (enhanceData.videoBitrate);
						sdpStrRet += '\r\nb=AS:' + (enhanceData.videoBitrate);
						if (enhanceData.videoFrameRate !== undefined) {
							sdpStrRet += '\r\na=framerate:' + enhanceData.videoFrameRate;
						}
					}
					hitMID = true;
				}
				else if ('bandwidth'.localeCompare(sdpSection) == 0) {
					var rtpmapID;
					rtpmapID = getrtpMapID(sdpLine);
					if (rtpmapID !== null) {
						var match = rtpmapID[2].toLowerCase();
						if (('vp9'.localeCompare(match) == 0) || ('vp8'.localeCompare(match) == 0) || ('h264'.localeCompare(match) == 0) ||
							('red'.localeCompare(match) == 0) || ('ulpfec'.localeCompare(match) == 0) || ('rtx'.localeCompare(match) == 0)) {
							if (enhanceData.videoBitrate !== undefined) {
								sdpStrRet += '\r\na=fmtp:' + rtpmapID[1] + ' x-google-min-bitrate=' + (enhanceData.videoBitrate) + ';x-google-max-bitrate=' + (enhanceData.videoBitrate);
							}
						}

						if (('opus'.localeCompare(match) == 0) || ('isac'.localeCompare(match) == 0) || ('g722'.localeCompare(match) == 0) || ('pcmu'.localeCompare(match) == 0) ||
							('pcma'.localeCompare(match) == 0) || ('cn'.localeCompare(match) == 0)) {
							if (enhanceData.audioBitrate !== undefined) {
								sdpStrRet += '\r\na=fmtp:' + rtpmapID[1] + ' x-google-min-bitrate=' + (enhanceData.audioBitrate) + ';x-google-max-bitrate=' + (enhanceData.audioBitrate);
							}
						}
					}
				}
			}
		}
		sdpStrRet += '\r\n';
	}
	return sdpStrRet;
}

export function getrtpMapID(line) {
	var findid = new RegExp('a=rtpmap:(\\d+) (\\w+)/(\\d+)');
	var found = line.match(findid);
	return (found && found.length >= 3) ? found : null;
}

export function errorHandler(error) {
	console.log(error);
}



// WEBPACK FOOTER //
// ./src/webrtc.js